import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as reduxForm from 'redux-form';
import { Condition } from '../../../../../../components/condition/condition';
import { LoadingSpinnerForModal } from '../../../../../../components/spinners/loading-spinner-for-modal/loading-spinner-for-modal';
import { StoreState } from '../../../../../../redux/reducers/store.types';
import { fromRenderProps } from '../../../../../../utils/fromRenderProps';

// TODO: remove this when FormName is officially added to @types/redux-form
const FormName: any = (reduxForm as any).FormName;

interface Props {
  isSubmitting: boolean;
}

const FormSubmittingOverlayComponent: React.FunctionComponent<Props> = ({
  isSubmitting,
}: Props) => (
  <Condition cond={isSubmitting}>
    <LoadingSpinnerForModal />
  </Condition>
);

export const FormSubmittingOverlay = compose(
  fromRenderProps(FormName, ({ form }) => ({ form })),
  connect((state: StoreState, { form }: { form: string }) => ({
    isSubmitting: reduxForm.isSubmitting(form)(state),
  })),
)(FormSubmittingOverlayComponent);
